import { render, staticRenderFns } from "./Reefer.vue?vue&type=template&id=61146074&scoped=true"
import script from "./Reefer.vue?vue&type=script&lang=js"
export * from "./Reefer.vue?vue&type=script&lang=js"
import style0 from "./Reefer.vue?vue&type=style&index=0&id=61146074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61146074",
  null
  
)

export default component.exports